import { useFormik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { trainerSchema } from "../../schema/schema";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import Select from "react-select";
import {
  trainerEndpoint,
  trainerLevelEndpoint,
  trainerLevels,
  updateTrainer,
} from "../../data/ApiEndpoints";
import {
  commonPostPutFormData,
  fetchApiData,
} from "../../redux/reducers/commonApiSlice";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import PlacesSearch from "../common-components/SearchedPlaces";
import { Form } from "react-bootstrap";
import { MultiSelect } from "react-multi-select-component";
import { useGetFetch } from "../../data/Queries";
import { fetchAllTrainersByExpLvlData } from "../../redux/reducers/apiSlice";
import { useGymFilter } from "../../hooks/useGymFilter";
import { getCapitalise } from "../../utils/utilityfunc";

const TrainerEdit = ({
  getTrainerData,
  closeModal,
  initialValues,
  token,
  isEdit,
  userInfoData,
}) => {
  const dispatch = useDispatch();
  const { gymData } = useGymFilter();
  const { data: trainerCategoryData } = useSelector((state) => state.common);

  const [TRAINER_LEVELS, setTRAINER_LEVELS] = useState([]);

  useEffect(() => {
    dispatch(fetchAllTrainersByExpLvlData("", userInfoData?.token));
  }, [dispatch, userInfoData?.token]);

  const getTrainerCategories = () => {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: "/trainer-category",
        token: userInfoData?.token,
        payload: {
          filters: "",
        },
      })
    );
  };

  console.log("initialValues", initialValues);

  useEffect(() => {
    getTrainerCategories();
  }, []);

  const TrainerCategoryOptions = useMemo(
    () =>
      trainerCategoryData?.data?.map((item) => {
        return {
          value: item?.uid,
          label: item?.name,
        };
      }) || [],
    [trainerCategoryData]
  );

  // get trainer levels
  const {
    data: trainerLevelData,
    isFetching: isFetchingTrainerLevel,
    isLoading: isLoadingTrainerLevel,
  } = useGetFetch({
    url: `${trainerEndpoint}${trainerLevelEndpoint}`,
    token,
    key: trainerLevels,
  });

  useEffect(() => {
    try {
      if (!isLoadingTrainerLevel && !isFetchingTrainerLevel) {
        const { data, status } = trainerLevelData;
        if (status) {
          const options = data.map((item) => {
            return {
              value: item.uid,
              label: getCapitalise(item.experience_level),
              ...item,
            };
          });
          if (options) {
            setTRAINER_LEVELS(options);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [trainerLevelData]);

  const formik = useFormik({
    initialValues: {
      ...initialValues,
      date_onboarding: initialValues?.date_onboarding
        ? moment(initialValues?.date_onboarding, "DD-MM-YYYY").isValid()
          ? moment(initialValues?.date_onboarding, "DD-MM-YYYY").format(
              "YYYY-MM-DD"
            )
          : ""
        : "",
    },
    validationSchema: trainerSchema,
    onSubmit: async (values) => {
      console.log("triggered", values);

      const formData = new FormData();
      formData.append("trainer_category_id", values?.trainer_category_id || "");
      formData.append("gym_id", values?.gym_id || "");
      formData.append("address1", values?.address1 || "");
      formData.append("address2", values?.address2 || "");
      formData.append("pin", values?.pin || "");
      formData.append("city", values?.city || "");
      formData.append("trainer_exp_lvl", values?.trainer_exp_lvl || "");
      formData.append("trainer_exp_pt", values?.trainer_exp_pt || "");
      formData.append("trainer_exp_gt", values?.trainer_exp_gt || "");
      formData.append(
        "date_onboarding",
        values?.date_onboarding
          ? moment(values?.date_onboarding).format("DD-MM-YYYY")
          : ""
      );
      formData.append("description", values?.description || "");
      formData.append("trainer_expt", values?.trainer_expt || "");
      formData.append("name", initialValues?.name || "");
      formData.append("trainer_id", initialValues?.user_id || "");
      formData.append(
        "shift_details",
        JSON.stringify(initialValues?.shift_details || [])
      );
      formData.append("trainer_lang", values.trainer_lang);
      formData.append("related_to", JSON.stringify(initialValues?.related_to));
      formData.append("pan_card", values?.pan_card || "");
      formData.append("aadhar_card", values?.aadhar_card || "");
      formData.append("state", values?.state || "");
      formData.append("status", values?.status || "");
      formData.append("uid", initialValues?.uid || "");

      // for (const key in initialValues) {
      //   if (!formData.has(key)) {
      //     formData.append(key, initialValues[key]);
      //   }
      // }

      const result = await dispatch(
        commonPostPutFormData({
          method: isEdit ? "PUT" : "POST",
          endpoint: isEdit ? updateTrainer : updateTrainer,
          requestBody: formData,
          token,
        })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        getTrainerData();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    },
  });

  const handlePlaceChange = (selectedLocation) => {
    formik.setFieldValue("address1", selectedLocation?.address1);
    formik.setFieldValue("address2", selectedLocation?.address2);
    formik.setFieldValue("city", selectedLocation?.city);
    formik.setFieldValue("pin", selectedLocation?.pincode);
    formik.setFieldValue("state", selectedLocation?.state);
  };

  const { data: expertiseData } = useGetFetch({
    url: "/trainer/expertise",
    token: "",
    filters: "",
    key: "",
    isPage: "",
  });

  const expertiseFormattedData = useMemo(() => {
    return (
      expertiseData?.data?.map((item) => ({
        label: item.name,
        value: item.uid,
        ...item,
      })) || []
    );
  }, [expertiseData]);

  console.log("formik", formik.values);
  console.log("formik errors", formik.errors);
  console.log("formik errors", formik.errors.trainer_expt);

  return (
    <div className="createNewCTOModalContainer mod-width-100p careerFormModal">
      <CommonHeadingNBtns
        title={`${isEdit ? "Edit" : "Add"} Trainer`}
        onClick={formik.handleSubmit}
        isLoading={formik.isSubmitting}
        btnTxt={isEdit ? "Update" : "Add"}
        onClose={closeModal}
      />

      <form
        className="formContainer formContainer__Trainer"
        onSubmit={formik.handleSubmit}
      >
        <div className="formInputsGrid fourGridSystem">
          <div className="formInputBox">
            <label className={`formInputLabel`}>
              Trainer Category <span className="text-danger">*</span>
            </label>
            <div className={`commonWrapper dropdownCommonWrapper `}>
              <Select
                options={TrainerCategoryOptions}
                value={TrainerCategoryOptions.find(
                  (option) =>
                    option.value === formik?.values?.trainer_category_id
                )}
                onChange={(opt) =>
                  formik?.setFieldValue("trainer_category_id", opt?.value)
                }
                id="trainer_category_id"
                name="trainer_category_id"
                // className="select__Input"
                placeholder="Select Trainer Category"
                isSearchable={true}
              />
            </div>

            {formik.touched.trainer_category_id &&
            formik.errors.trainer_category_id ? (
              <div className="error-message">
                {formik.errors.trainer_category_id}
              </div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label className={`formInputLabel`}>
              Gym <span className="text-danger">*</span>
            </label>
            <div
              className={`commonWrapper dropdownCommonWrapper trainerGymDropDown`}
            >
              <Select
                options={gymData?.length > 0 ? gymData : []}
                value={gymData.find(
                  (gym) => gym?.value === formik?.values?.gym_id
                )}
                onChange={(opt) => formik?.setFieldValue("gym_id", opt?.value)}
                id="gym_id"
                name="gym_id"
                className="select__Input"
                placeholder="Select Gym"
                isSearchable={true}
                isDisabled={isEdit}
              />
            </div>

            {formik.touched.gym_id && formik.errors.gym_id ? (
              <div className="error-message">{formik.errors.gym_id}</div>
            ) : null}
          </div>

          <div className="formInputBox searchInput">
            <label htmlFor="searchedLocation" className="formInputLabel">
              Search location
            </label>

            <div className={`commonWrapper dropdownCommonWrapper`}>
              <PlacesSearch handlePlaceChange={handlePlaceChange} />
            </div>
          </div>

          <div className="formInputBox">
            <label className="formInputLabel">Address 1</label>
            <div className="formWapper">
              <input
                type="text"
                name="address1"
                className="inputClass"
                placeholder="Address 1"
                value={formik.values.address1}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.address1 && formik.errors.address1 ? (
              <div className="error-message">{formik.errors.address1}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label className="formInputLabel">Address 2</label>
            <div className="formWapper">
              <input
                type="text"
                name="address2"
                className="inputClass"
                placeholder="Address 2"
                value={formik.values.address2}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.address2 && formik.errors.address2 ? (
              <div className="error-message">{formik.errors.address2}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label className="formInputLabel">City</label>
            <div className="formWapper">
              <input
                type="text"
                name="city"
                className="inputClass"
                placeholder="City"
                value={formik.values.city}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.city && formik.errors.city ? (
              <div className="error-message">{formik.errors.city}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label className="formInputLabel">State</label>
            <div className="formWapper">
              <input
                type="text"
                name="state"
                className="inputClass"
                placeholder="state"
                value={formik.values.state}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.state && formik.errors.state ? (
              <div className="error-message">{formik.errors.state}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label className="formInputLabel">Pin</label>
            <div className="formWapper">
              <input
                type="text"
                name="pin"
                className="inputClass"
                placeholder="pin"
                value={formik.values.pin}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.pin && formik.errors.pin ? (
              <div className="error-message">{formik.errors.pin}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label className={`formInputLabel`}>
              Trainer Experience Level <span className="text-danger">*</span>
            </label>
            <div className={`commonWrapper dropdownCommonWrapper `}>
              <Select
                options={TRAINER_LEVELS}
                value={TRAINER_LEVELS.find(
                  (option) => option.value === formik?.values?.trainer_exp_lvl
                )}
                onChange={(opt) =>
                  formik?.setFieldValue("trainer_exp_lvl", opt?.value)
                }
                id="trainer_exp_lvl"
                name="trainer_exp_lvl"
                placeholder="Select Trainer Experience Level"
                isSearchable={true}
              />
            </div>

            {formik.touched.trainer_exp_lvl && formik.errors.trainer_exp_lvl ? (
              <div className="error-message">
                {formik.errors.trainer_exp_lvl}
              </div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label className="formInputLabel">
              Trainer Language <span className="text-danger">*</span>
            </label>
            <div className="formWapper">
              <input
                type="text"
                name="trainer_lang"
                className="inputClass"
                placeholder="Trainer Language"
                value={formik.values.trainer_lang}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.trainer_lang && formik.errors.trainer_lang ? (
              <div className="error-message">{formik.errors.trainer_lang}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label className="formInputLabel">
              Experience as Personal Trainer{" "}
              <span className="text-danger">*</span>
            </label>
            <div className="formWapper">
              <input
                type="text"
                name="trainer_exp_pt"
                className="inputClass"
                placeholder="Experience as Personal Trainer"
                value={formik.values.trainer_exp_pt}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.trainer_exp_pt && formik.errors.trainer_exp_pt ? (
              <div className="error-message">
                {formik.errors.trainer_exp_pt}
              </div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label className="formInputLabel">
              Experience as General Trainer{" "}
              <span className="text-danger">*</span>
            </label>
            <div className="formWapper">
              <input
                type="text"
                name="trainer_exp_gt"
                className="inputClass"
                placeholder="Experience as General Trainer"
                value={formik.values.trainer_exp_gt}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.trainer_exp_gt && formik.errors.trainer_exp_gt ? (
              <div className="error-message">
                {formik.errors.trainer_exp_gt}
              </div>
            ) : null}
          </div>

          <div
            className="formInputBox"
            style={{
              gridColumn: "span 1",
            }}
          >
            <label className="formInputLabel">
              Joining Date <span className="text-danger">*</span>
            </label>
            <div className="formWapper">
              <input
                type="Date"
                name="date_onboarding"
                className={`formInput ${
                  formik?.errors?.date_onboarding ? "formError" : ""
                } ${formik?.values?.date_onboarding ? "date-has-value" : ""}`}
                placeholder="Joining Date"
                value={formik?.values?.date_onboarding}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{ color: "#f2f" }}
              />
            </div>

            {formik.touched.date_onboarding && formik.errors.date_onboarding ? (
              <div className="error-message">
                {formik.errors.date_onboarding}
              </div>
            ) : null}
          </div>

          <div
            className="formInputBoxMultiSelect"
            style={{
              gridColumn: "span 2",
              // background: "#f2f",
            }}
          >
            <label className="formInputLabel">
              Trainer Expertise <span className="text-danger">*</span>
            </label>
            <div className="formInputBoxMultiSelect__Input">
              <MultiSelect
                options={
                  expertiseFormattedData?.length > 0
                    ? expertiseFormattedData
                    : []
                }
                value={
                  expertiseFormattedData &&
                  expertiseFormattedData.filter((item) =>
                    (formik.values.trainer_expt || [])?.includes(item.value)
                  )
                }
                onChange={(selected) => {
                  const selectedValues = selected
                    .map((item) => item.value)
                    .join(",");
                  formik.setFieldValue("trainer_expt", selectedValues);
                }}
                name="trainer_expt"
                preventKeyboardOpen={true}
                isShowList={true}
              />
            </div>

            {formik.touched.trainer_expt && formik.errors.trainer_expt ? (
              <div className="error-message">{formik.errors.trainer_expt}</div>
            ) : null}
          </div>
          <br />
          <div
            className="formInputBox"
            style={{
              gridColumn: "span 4",
            }}
          >
            <label className="formInputLabel">Description</label>
            <textarea
              type="text"
              name="description"
              // className="input-k"
              placeholder="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              style={{
                width: "100%",
                height: "100px",
                padding: "14px",
                borderRadius: "10px",
                outline: "none",
                fontSize: "16px !important",
              }}
            />
            {formik.touched.description && formik.errors.description ? (
              <div className="error-message">{formik.errors.description}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label className="formInputLabel">Pan Card</label>
            <input
              type="file"
              name="pan_card"
              className={`formInput`}
              onChange={(event) =>
                formik.setFieldValue("pan_card", event.target.files[0])
              }
            />

            {formik.touched.pan_card && formik.errors.pan_card ? (
              <div className="error-message">{formik.errors.pan_card}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label className="formInputLabel">Aadhar Card</label>
            <input
              type="file"
              name="aadhar_card"
              className={`formInput`}
              onChange={(event) =>
                formik.setFieldValue(
                  "aadhar_card",
                  event.currentTarget.files[0]
                )
              }
            />

            {formik.touched.aadhar_card && formik.errors.aadhar_card ? (
              <div className="error-message">{formik.errors.aadhar_card}</div>
            ) : null}
          </div>
{/* 
          <div
            className="formInputsGrid switchInputs"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "end",
            }}
          >
            <div className="formInputBox formInputSwitchBox">
              <div className={`commonWrapper commonSwitchWrapper no-border`}>
                <Form.Check
                  type="switch"
                  name="isActive"
                  label={formik?.values?.status}
                  checked={formik.values.status === "active"}
                />
              </div>
            </div>
          </div> */}
        </div>
      </form>
    </div>
  );
};

export default TrainerEdit;

// const onChangeInput = (e) => {
//   const { checked } = e.target;
//   if (checked === true) {
//     formik.setFieldValue("status", "active");
//   } else {
//     formik.setFieldValue("status", "inactive");
//   }
// };
